import React from 'react';
import moment from 'moment';

const DateCurrentDisplay = () => {
    return (
        <p className="text-right mt-2 mb-1 mr-2 blue-text">
            <i>Generated on: {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
        </p>
    );
};

export default DateCurrentDisplay;